import { Box } from '@vk-hr-tek/ui/Box';
import { Skeleton } from '@vk-hr-tek/ui/Skeleton';
import { Typography } from '@vk-hr-tek/ui/Typography';
import { Link } from '@vk-hr-tek/ui/Link';
import { useQuery } from '@vk-hr-tek/core/query';

import { useDispatch, useSelector } from '@app/hooks';

import {
  selectBellNotificationsStatus,
  selectBellNotificationsWithDateGroups,
  selectBellCounter,
  markBellReadAll,
  selectIsBellMarkReadAllPending,
} from '../../../../slice';
import { NotificationsFiltersDto } from '../../../../dto';
import { NOTIFICATIONS_STATUSES } from '../../../../constants';

export const Header = () => {
  const status = useSelector(selectBellNotificationsStatus);
  const items = useSelector(selectBellNotificationsWithDateGroups);
  const counter = useSelector(selectBellCounter);
  const isMarkReadLoading = useSelector(selectIsBellMarkReadAllPending);

  const dispatch = useDispatch();

  const [filter] = useQuery<NotificationsFiltersDto>(NotificationsFiltersDto);

  const activeFilters = filter?.filters || {};

  const handleMarkReadAll = () => {
    dispatch(
      markBellReadAll({
        removeFromList: activeFilters.status === NOTIFICATIONS_STATUSES.UNREAD,
      }),
    );
  };

  return (
    <Box
      p="16"
      border={1}
      borderTop={0}
      borderLeft={0}
      borderRight={0}
      borderColor="stroke.primary"
      display="flex"
      justifyContent="space-between"
      alignItems="center"
    >
      <Typography variant="subtitle1">Уведомления</Typography>
      {status === 'loading' && (
        <Skeleton variant="rect" height={20} width={192} />
      )}
      {status !== 'loading' && !!counter && (
        <Link
          testId="test-id-mark-all-notifications-read"
          disabled={isMarkReadLoading || !items.length}
          stroke={false}
          variant="secondary"
          onClick={handleMarkReadAll}
        >
          Отметить все прочитанным
        </Link>
      )}
    </Box>
  );
};
